import http from '@/http'
import router from '@/router'

export default {
  namespaced: true,
  state: {
    accessToken: null,
    refreshToken: null,
    user: {},
  },
  mutations: {
    TOKEN_UPDATE(state, { accessToken, refreshToken }) {
      state.accessToken = accessToken
      state.refreshToken = refreshToken
      if (accessToken) {
        state.user = Object(
          JSON.parse(Buffer.from(accessToken.split('.')[1], 'base64').toString('utf8'))
        )
        localStorage.setItem('store', JSON.stringify(state))
      } else {
        state.user = null
      }
    },
  },
  actions: {
    async login(context, form) {
      const formData = new FormData()
      formData.append('username', form.username)
      formData.append('password', form.password)
      formData.append('grant_type', 'password')
      formData.append('client_id', 'client')
      formData.append('client_secret', 'client')

      const response = await http.post('oauth/token', formData)

      const accessToken = response.data.access_token
      const refreshToken = response.data.refresh_token || null

      context.commit('TOKEN_UPDATE', {
        accessToken,
        refreshToken,
      })

      return response
    },
    async me() {
      const response = await http.get('oauth/me')

      return response
    },
    async loginBehindCustomer(context, customerId) {
      const formData = new FormData()
      formData.append('clientId', 'client')
      formData.append('customerId', customerId)

      const response = await http.post('oauth/customer/token', formData)

      return response
    },
    async logout(context) {
      context.commit('TOKEN_UPDATE', {
        accessToken: null,
        refreshToken: null,
      })
      localStorage.removeItem('store')
      if (router.currentRoute.name !== 'login') {
        await router.push({
          name: 'login',
        })
      }
    },
    authPromise(context) {
      return new Promise((resolve, reject) => {
        const data = new FormData()
        data.append('client_id', 'client')
        data.append('client_secret', 'client')
        data.append('grant_type', 'refresh_token')
        data.append('refresh_token', context.state.refreshToken)

        http
          .post('oauth/token', data)
          .then((response) => {
            if (response.status !== 200) {
              return reject(new Error(response.status))
            }
            const accessToken = response.data.access_token
            const refreshToken = response.data.refresh_token
            context.commit('TOKEN_UPDATE', {
              accessToken,
              refreshToken,
            })

            return resolve(response)
          })
          .catch((error) => reject(error))
      })
    },
  },
}
